import { Component, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { WebhookLogDetail } from '../../core/models/api.models';

@Component({
  selector: 'app-webhook-log-detail',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './webhook-log-detail.component.html',
  styleUrl: './webhook-log-detail.component.scss',
})
export class WebhookLogDetailComponent implements OnInit {
  private readonly api = inject(ApiService);
  private readonly route = inject(ActivatedRoute);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly log = signal<WebhookLogDetail | null>(null);

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    const provider = this.route.snapshot.paramMap.get('provider');
    const source = this.route.snapshot.queryParamMap.get('source');
    if (!id || !provider) {
      this.error.set('Missing webhook log id or provider');
      return;
    }
    this.load(id, provider, source);
  }

  load(id: string, provider: string, source: string | null): void {
    this.loading.set(true);
    this.error.set(null);
    this.api.getWebhookLogById(id, provider, source).subscribe({
      next: (data) => {
        this.log.set(data);
        this.loading.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load webhook log');
        this.loading.set(false);
      },
    });
  }

  pretty(value: string | null | undefined): string {
    if (!value) return '—';
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
}
